import React from "react";
import MainPage from "./MainPage";
// 'PageView' Component is Combine with Context Hook, So we can use 'setPageView' from any children and check the current Page View.
// Or we can say that this component is use to manage the view, we can show/Hide modals, alerts through this component.
// We can check which component is rending now(Current Page).
import PageView from "./StatesMangement/ViewMangement";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PageNotFound from "./CommonComponents/PageNotFound";
// 'Records' Component is Combine with Context Hook, so we can fetch records/details for INVOICE_1, INVOICE_2 and CLIENT_PORTAL in any child component.
// Through this we can set the fetched records. and use them in any child component.
import Records from "./StatesMangement/RecordsManagement";
import MobileLinkPage from "./MobileLinkPage";

function App() {
    // This GotoMainPage Component Works only If Route Path is '/client_estimate'.
    const GotoMainPage = () => {
        return (
            <PageView>
                <Records>
                    <MainPage/>
                </Records>
            </PageView>
        );
    }

    // This GotoMobileLinkPage Component Works only If Route Path is '/client_estimate_mobile_link'.
    const GotoMobileLinkPage = () => {
        return (
            <PageView>
                <Records>
                    <MobileLinkPage/>
                </Records>
            </PageView>
        );
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/client_estimate" element={<GotoMainPage/>}></Route>
                <Route path="/client_storage" element={<GotoMainPage/>}></Route>
                <Route path="/client_estimate_mobile_link" element={<GotoMobileLinkPage/>}></Route>
                <Route path="*" element={<PageNotFound/>}></Route>
            </Routes>
        </BrowserRouter>
    ); // This returns MainPage If Route Path is '/client_estimate' Else it will render 'Page Not Found' Page.
}

export default App;